import {StoreConstants} from '../constants/store.constants';
import type {AnyPayloadAction, DbState} from '../models/store.models';
import {storeState} from '../models/store.models';

export function DbReducer(state: DbState = storeState.Db, action: AnyPayloadAction): DbState {
  if (action.group !== StoreConstants.StoreGroups.Db) return state;

  switch (action.type) {
    case StoreConstants.Db.DB_READY:
      return {
        ...state,
        dbReady: action.dbReady
      };

    case StoreConstants.Db.DATA_READY:
      return {
        ...state,
        dataReady: action.dataReady
      };

    case StoreConstants.Db.FEED:
      return {
        ...state,
        feed: action.feed
      };

    case StoreConstants.Db.SYNC:
      return {
        ...state,
        sync: action.sync
      };

    default:
      return state;
  }
}
